import KValidationProvider from "./KValidationProvider";
import { VFileInput } from "vuetify/lib";

export default VFileInput.extend( {
	name: "KTextField",

	mixins: [ KValidationProvider ],

	props: {
		color: {
			default: "link",
			type: String
		}
	},

	computed: {
		propsToPass() {
			const props = {};

			Object.keys( this.$props ).forEach( prop => {
				if ( prop in VFileInput.options.props ) {
					props[prop] = this.$props[prop];
				}
			} );

			return props;
		}
	},

	methods: {
		genValidatableField( props ) {
			return <VFileInput
				attrs={{
					...this.$attrs,
					...this.propsToPass,
					errorMessages: props.errors
				}}
				on={{ ...this.$listeners }}
				scopedSlots={this.$scopedSlots}
				vModel={this.internalValue}
			>
				{Object.keys( this.$slots ).map( slot =>
					<template slot={slot} key={slot}>{this.$slots[slot]}</template>
				)}
			</VFileInput>;
		}
	},

	render() {
		return this.genValidationProvider();
	}
} );
